module.exports = __webpack_public_path__ + "img/材料力学8_3_1.8068ea0c.jpg";